module.exports = __webpack_public_path__ + "assets/img/block-right-dccbef23.png";